module.exports = __webpack_public_path__ + "static/media/NoLinksSCM.4b908eaf.svg";